<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3 class="card-title">Daftar Kategori Barang</h3>
            </div>  
        </div>
        <div class="row">

          <div class="col-12">

            <div class="card" v-if="$gate.isAdmin1()">
              <div class="card-header">
                <!--<button type="button" class="btn btn-sm btn-primary" @click="newModal">
                    <i class="fa fa-plus-square"></i>
                    Tambah Kategori Barang
                </button>-->

                
                  <div class="card-tools">
                    <input type="text" v-model="searchTerm"  placeholder="Cari">
                </div>
               
                
                
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <!--th>ID</th-->
                      <th role='button' v-on:click="sortRecords('TahunKode')">Kode Rekening</th>
                      <th role='button' v-on:click="sortRecords('Nama')">Nama Kategori</th>
                      <th role='button' v-on:click="sortRecords('Tingkat')">Tingkat</th>
                      <!--<th>Action</th>-->
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="kategori_barang in kategori_barangs.data" :key="kategori_barang.id">

                      <!--td>{{kategori_barang.id}}</td-->
                      <td>{{kategori_barang.TahunKode}}</td>
                      <td class="text-capitalize">{{kategori_barang.Nama}}</td>
                      <td>{{kategori_barang.Tingkat}}</td>
                      <!--<td>

                        <a href="#" @click="editModal(kategori_barang)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                      </td>-->
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">                  
                  <div class="row">
                        <div class="col-6" style="margin-top:10px;">
                                Menampilkan <select v-model="pageShow" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Baris
                        </div>

                        <div class="col-6">
                            <pagination style="float:right;" :data="kategori_barangs" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!$gate.isAdmin1()">
            <not-found></not-found>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Kategori Barang</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Kategori Barang</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateKategoriBarang() : createKategoriBarang()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Kode Rekening</label>
                            <input v-model="form.TahunKode" type="text" name="TahunKode"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('TahunKode') }">
                            <has-error :form="form" field="TahunKode"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Nama Kategori Barang</label>
                            <input v-model="form.Nama" type="text" name="Nama"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Nama') }">
                            <has-error :form="form" field="Nama"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Tingkat</label>
                            <select v-model="form.Tingkat" class="form-control" :class="{ 'is-invalid': form.errors.has('Tingkat') }">
                                <option disabled value="">Pilih salah satu</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option default>6</option>
                            </select>
                            <has-error :form="form" field="Tingkat"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                searchTerm:'',
                limit : 0,
                kategori_barangs : {},
                form: new Form({
                    id : '',                    
                    TahunKode: '',
                    Nama: '',
                    Tingkat: '',
                }),
                sortIndex: 'Nama',
                sortDirection: 'asc',
                pageShow:10,
            }
        },
        methods: {
            sortRecords (index) {
               
                this.sortIndex = index;
                if(this.sortDirection == 'asc'){
                   this.sortDirection = 'desc';
                }else if(this.sortDirection == 'desc'){
                   this.sortDirection = 'asc';
                }else{
                   this.sortDirection = 'asc';
                }
                
                this.$Progress.start();
                  
                axios.get('/api/kategori_barang?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.kategori_barangs = data.data));

                this.$Progress.finish();
            },    
            changePageRange(){
                //alert(this.pageShow);
                this.$Progress.start();
                  
                  axios.get('/api/kategori_barang?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.kategori_barangs = data.data));

                  this.$Progress.finish();
            },  
            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('/api/kategori_barang?page=' + page + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.kategori_barangs = data.data));

                  this.$Progress.finish();
            },
            updateKategoriBarang(){
                this.$Progress.start();
                this.form.put('/api/kategori_barang/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadKategoriBarangs();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(kategori_barang){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(kategori_barang);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            loadKategoriBarangs(){
                let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                if(this.$gate.isAdmin1()){
                    axios.get("/api/kategori_barang?search=" + param + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.kategori_barangs = data.data));
                }
            },
            
            createKategoriBarang(){

                this.form.post('/api/kategori_barang')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadKategoriBarangs();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            }

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {

            this.$Progress.start();
            this.loadKategoriBarangs();
            this.$Progress.finish();
        },
        watch: {
            searchTerm: function() {
                this.loadKategoriBarangs();
            }
        }
    }
</script>